<template>
    <div class="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div class="text-center">
        <img :src="svgPath" class="img-fluid mb-4" alt="Settings">
        <h1 class="display-4">Under Construction</h1>
        <p class="lead">We are working hard to bring you a great experience. Stay tuned!</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        svgPath: '/storage/settings/settings.svg'
      };
    }
  }
  </script>
  
  <style scoped>
  .bg-light {
    background-color: #f8f9fa !important;
  }
  .img-fluid {
    max-width: 100%;
    height: auto;
  }
  </style>
  